// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"36f01a95","660":"2ebf5598","848":"321cad83"}[chunkId] + ".chunk.css";
};